export enum EIAStatus {
  DRAFT = "draft",
  PENDING_EMPLOYEE = "pending_employee",
  PENDING_MANAGER = "pending_manager",
  PENDING_MANAGER_N2 = "pending_manager_n2",
  VALIDATED = "validated",
}
